<template lang="pug">
#green_apet_sheet
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_green_apet_sheet.jpg" alt="banner green apet sheet")
        img.img-fluid.small(src="img/banner/banner_green_apet_sheet_mobile.jpg" alt="banner green apet sheet")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
        //- router-link(to="/#application" ) 123
    div.banner_h1
      h1 GREEN APET
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 南亞塑膠公司秉持著永續經營的精神，致力於環境保護，推出GREEN APET產品，採用PCR粒為原料，減少碳排放，降低環境衝擊。
  section#product_profile
    b-row.menu
      b-col.text-center.active APET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品證書
            a.linkcus(href="img/certification/GRS_Certificate.pdf" target="_blank")
              figure
                figcaption GRS 證書
                img(src="img/certification/GRS_Certificate.jpg" alt="GRS Certificate")
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span  APET 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_3
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'GREEN APET-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: '南亞塑膠公司秉持著永續經營的精神，致力於環境保護，推出GREEN APET產品，採用PCR粒為原料，減少碳排放，降低環境衝擊。PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、Apet、PCR粒、環境保護、減少碳排放。' },
            { name: 'og:title', content: 'GREEN APET-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          // {
          //   text: '應用',
          //   to: { name: 'App' },
          //   scroll: '#application'
          // },
          {
            text: 'GREEN APET',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/green_apet_01.jpg',
            img_alt: '南亞塑膠公司秉持著永續經營的精神，致力於環境保護，推出GREEN APET產品，採用PCR粒為原料，減少碳排放，降低環境衝擊。' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/green_apet_02.jpg',
            img_alt: '南亞塑膠公司秉持著永續經營的精神，致力於環境保護，推出GREEN APET產品，採用PCR粒為原料，減少碳排放，降低環境衝擊。' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/green_apet_03.jpg',
            img_alt: '南亞塑膠公司秉持著永續經營的精神，致力於環境保護，推出GREEN APET產品，採用PCR粒為原料，減少碳排放，降低環境衝擊。' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: '添加PCR粒之RPET膠布，取得GRS認證。' },
          { message: '雜質、疵點少。' },
          { message: '成型性與純原料相當。' }
        ],
        a_use: [
          { message: '產品分三級：(1)RA：PCR含量.20%。(2)RB：PCR含量50%。(3)RC：PCR含量90~100%。' },
          { message: '經真空成型後製作內襯、玩具、工具盒、電子Tray盤等商品之包裝材料' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'GREEN APET膠布 AVVR-RA',
            feature: '特色: 取得GRS 證書、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.4',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">84～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">155～165</span>',
            mist: '霞霧度<sub>(%)</sub>：3.2↓'},
          { 
            id: '2',
            name: 'GREEN APET膠布 AVVR-RB',
            feature: '特色: 取得GRS 證書、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.4',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">82～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">150～165</span>',
            mist: '霞霧度<sub>(%)</sub>：3.5↓'},
          { 
            id: '3',
            name: 'GREEN APET膠布 AVVR-RC',
            feature: '特色: 取得GRS 證書、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.4',
            proportion: '比重<sub>(g/cm3)</sub>：1.34±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">80～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">140～165</span>',
            mist: '霞霧度<sub>(%)</sub>：4.7↓'}
        ],
        swiperOption_apet: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            1170: {
              spaceBetween: 30,
              slidesPerView: 'auto',
            },
            991: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'食藥醫療',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'抗靜電包裝',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'建材裝潢',
            text:'在連續基材上，經過印刷、塗佈、貼合或壓製等工藝而製成的產品。 複合塑膠建材裝璜產品是由多層結構熱壓而成..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'卡片貼合',
            text:'本製品可經印刷、貼合、衝卡、打碼、分卡質檢等工序製成各種卡片。',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'事務文具',
            text:'本製品可經印刷、貼合、沖裁或熔著等工序製成各種事務文具用產品。',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'水處理',
            text:'本製品之加工方式有軋壓及成型兩種。客戶若使用成型方式加工，則須特別管制成型性。',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'Cpet-sheet'
          },
          {
            id:'8',
            name:'C-PET膠布',
            text:'C-PET膠布需經由壓空成型機模具加熱成型使其結晶，成型品可耐高溫。',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#green_apet_sheet
  #specification
    background-image: url(../assets/bg/bg_green_apet.jpg)
.linkcus,.linkcus:hover
  text-decoration: none
  color: #1E1E1E
  figure
    padding-right: 15px
    text-align: center
    display: inline-block
    figcaption
      padding-bottom : 8px
</style>
